<template>
  <focus-trap>
    <div
      tabindex="-1"
      class="modal d-block"
      @click.self="decline"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
      >
        <div class="modal-content rounded-10px">
          <div class="modal-header p-4">
            <div class="modal-title">
              <h5 class="font-weight-semibold mb-0">
                Restore Organization
              </h5>
            </div>
            <button
              type="button"
              class="close-2"
              aria-label="Close"
              @click="decline"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-4">
            <p class="font-weight-semibold text-break">
              Are you sure you want to restore the
              {{ organization.name }} Organization?
            </p>

            <div
              class="flex-center-between flex-wrap flex-lg-nowrap mb-4"
              style="gap: 10px"
            >
              <div
                class="border py-2 px-3 rounded text-center w-100"
                style="min-width: 170px"
              >
                Admins:
                <i
                  v-if="loading"
                  class="fa fa-spinner fa-spin"
                />
                <p
                  v-else
                  class="font-weight-bold text-green mb-0"
                >
                  {{ hasUser?.toLocaleString(locale) }}
                </p>
              </div>
              <div
                class="border py-2 px-3 rounded text-center w-100"
                style="min-width: 170px"
              >
                Teams:
                <i
                  v-if="loading"
                  class="fa fa-spinner fa-spin"
                />
                <p
                  v-else
                  class="font-weight-bold text-green mb-0"
                >
                  {{ hasTeam?.toLocaleString(locale) }}
                </p>
              </div>
              <div
                class="border py-2 px-3 rounded text-center w-100"
                style="min-width: 170px"
              >
                Members:
                <i
                  v-if="loading"
                  class="fa fa-spinner fa-spin"
                />
                <p
                  v-else
                  class="font-weight-bold text-green mb-0"
                >
                  {{ hasMember?.toLocaleString(locale) }}
                </p>
              </div>
              <div
                class="border py-2 px-3 rounded text-center w-100"
                style="min-width: 170px"
              >
                TinyURLs:
                <i
                  v-if="loading"
                  class="fa fa-spinner fa-spin"
                />
                <p
                  v-else
                  class="font-weight-bold text-green mb-0"
                >
                  {{ hasTinyurl?.toLocaleString(locale) }}
                </p>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6 mb-3 mb-md-0">
                <button
                  type="button"
                  class="btn btn-block py-2 text-lg rounded-10px btn-outline-blue"
                  @click="decline"
                >
                  Close
                </button>
              </div>
              <div class="col-md-6 mb-0">
                <button
                  type="button"
                  class="btn btn-block py-2 text-lg rounded-10px btn-blue"
                  @click="confirm"
                >
                  Restore Organization
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </focus-trap>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "RestoreOrganization",

  props: {
    organization: {
      type: Object,
      required: true,
    },

    callback: {
      type: Function,
      required: true,
    },
  },

  data: () => ({
    confirmed: false,

    tinyurls: [],
    members: [],

    hasTinyurl: undefined,
    hasUser: undefined,
    hasTeam: undefined,
    hasMember: undefined,
  }),

  computed: {
    ...mapGetters(["locale"]),

    loading() {
      return (
        this.hasTinyurl === undefined ||
        this.hasUser === undefined ||
        this.hasTeam === undefined ||
        this.hasMember === undefined
      );
    },
  },

  destroyed() {
    Bus.$off("closePopover1");
    this.callback(this.confirmed);
  },

  created() {
    this.setTinyurls();
    this.setUsers();
    this.setTeams();
    this.setMembers();
  },

  mounted() {
    Bus.$on("closePopover1", this.decline);
  },

  methods: {
    ...mapActions(["fetchOrgUsers", "fetchTeamMembers"]),

    confirm() {
      this.confirmed = true;
      this.$emit("close");
    },

    decline() {
      this.confirmed = false;
      this.$emit("close");
    },

    setTinyurls(next) {
      let url = this.$apiUrl("organization/{o}/urls/available", {
        o: this.organization.slug,
      });

      if (next) url = `${url}?page=${next}`;

      axios.get(url).then(({ data }) => {
        this.tinyurls = [...this.tinyurls, ...data.data];

        if (data?.next) {
          this.setTinyurls(data.next);
        } else {
          this.hasTinyurl = this.tinyurls.length;
        }
      });
    },

    setUsers() {
      this.fetchOrgUsers({
        params: { org: this.organization.slug },
        options: {
          force: true,
          callback: (data) => (this.hasUser = data.length),
        },
      });
    },

    setTeams() {
      this.hasTeam = this.organization.teams?.length;
    },

    setMembers() {
      const members = [];
      const promises = [];

      if (this.hasTeam) {
        this.organization.teams.forEach((team) => {
          promises.push(
            this.fetchTeamMembers({
              org: this.organization.slug,
              team: team.slug,
            }),
          );
        });
      }

      Promise.allSettled(promises).then((results) => {
        results.forEach(({ status, value }) => {
          if (status == "fulfilled") {
            value.data.data.forEach((d) => {
              if (!members.some((m) => m.email == d.email)) {
                members.push(d);
              }
            });
          }
        });

        this.hasMember = members.length;
      });
    },
  },
};
</script>
